module.exports = __webpack_public_path__ + "static/media/video-banner.308a045d.png";